import { defineMessages } from "react-intl"

export const messages = defineMessages({
    NoPayoutsProcessedTitle: {
        id: "payment_processing.payment_listing.no_payouts_processed_title",
        defaultMessage: "Receive your first payouts"
    },
    NoPayoutsProcessedDescription: {
        id: "payment_processing.payment_listing.no_payouts_processed_description",
        defaultMessage: "Your bank account is now linked and you may start receiving payouts."
        + " Once you process your first payments, a payouts summary and listing will display here."
    },


})


// WEBPACK FOOTER //
// ./src/payment-processing/payout-listing/messages.ts